/*
 * QBounce blog (snippets/qb-blog.liquid). Loaded only on blog templates (qb-revamp-head).
 * - topic pills: show the articles of one topic; the small ball rests in the picked pill, jumps out to the next
 *   one picked on a real arc (steady sideways speed, gravity, backspin) and drops through that pill's fixed hoop (the
 *   rim is drawn over the ball, so it passes behind it): rim flash and dip, the net catches it (stretch, squash),
 *   it settles in the hoop; on load it falls into the All hoop;
 * - search: filters the cards as you type (title, topic, first lines), together with the picked topic;
 *   Enter does not leave the page; without this script the field is the store's article search;
 * - while a topic or a search is on, the latest story area and the shop card step aside and every match shows
 *   in the grid, dealt in again with the drop-and-settle; the picked topic is kept in the address (#topic);
 * - Show more opens the next nine cards (count + bar), focus moves to the first new one;
 * - cards below the first screen drop in as they scroll into view.
 * Reduced motion: no rolling, dealing or dropping; everything still works.
 */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO = 'IntersectionObserver' in window;
  var STEP = 9;

  function init(root) {
    var grid = root.querySelector('[data-qb-bl-grid]');
    if (!grid) return;
    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-qb-bl-card]'));
    var pills = Array.prototype.slice.call(root.querySelectorAll('[data-qb-bl-topic]'));
    var track = root.querySelector('.qb-bl-topics__track');
    var scroller = root.querySelector('[data-qb-bl-topics]');
    var ball = root.querySelector('[data-qb-bl-ball]');
    var hop = ball && ball.querySelector('.qb-bl-ball__hop');
    var svg = ball && ball.querySelector('.qb-ball');
    var input = root.querySelector('[data-qb-bl-q]');
    var form = root.querySelector('[data-qb-bl-search]');
    var clear = root.querySelector('[data-qb-bl-clear]');
    var status = root.querySelector('[data-qb-bl-status]');
    var empty = root.querySelector('[data-qb-bl-empty]');
    var storeSearch = root.querySelector('[data-qb-bl-storesearch]');
    var more = root.querySelector('[data-qb-bl-more]');
    var moreWrap = root.querySelector('[data-qb-bl-morewrap]');
    var count = root.querySelector('[data-qb-bl-count]');
    var bar = root.querySelector('[data-qb-bl-bar]');
    var later = cards.filter(function (c) { return c.classList.contains('qb-bl-card--later'); });
    var total = cards.length;
    var topic = 'all';
    var query = '';
    var ballX = 0, ballY = 0, ballAnim = null;

    /* --- ball: rests in the picked pill's slot, jumps to the next and dunks through its hoop ------------- */
    var ballTimer = 0;

    function slotPos(p) {
      var slot = p.querySelector('.qb-bl-pill__slot');
      var tr = track.getBoundingClientRect();
      var sr = (slot || p).getBoundingClientRect();
      var bw = ball.offsetWidth || 17;
      /* resting in the net, just under the rim (rim at 48% of the slot, ball centre at 63%) */
      return { x: sr.left - tr.left + sr.width / 2 - bw / 2, y: sr.top - tr.top + sr.height * 0.63 - bw / 2 };
    }

    function tf(x, y, k) {
      return 'translate3d(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px,0)' + (k && k !== 1 ? ' scale(' + k + ')' : '');
    }

    /* the hoop reacts as the ball goes through: rim flashes and dips, net stretches */
    /* the rim sits this far above the resting ball's centre (fixed hoop) */
    var RIM = 4;

    function swish(p) {
      var flash = p.querySelector('.qb-bl-hoop__flash');
      var net = p.querySelector('.qb-bl-hoop__net');
      var rim = p.querySelector('.qb-bl-hoop__rim');
      if (flash && flash.animate) flash.animate([{ opacity: 0 }, { opacity: 1, offset: 0.25 }, { opacity: 0 }], { duration: 420, easing: 'ease-out' });
      if (net && net.animate) net.animate([{ transform: 'scaleY(1)' }, { transform: 'scaleY(1.45)', offset: 0.3 }, { transform: 'scaleY(0.9)', offset: 0.65 }, { transform: 'scaleY(1)' }], { duration: 460, easing: 'ease-out' });
      if (rim && rim.animate) rim.animate([{ transform: 'translateY(0)' }, { transform: 'translateY(1.4px)', offset: 0.3 }, { transform: 'translateY(-0.4px)', offset: 0.7 }, { transform: 'translateY(0)' }], { duration: 380, easing: 'ease-out' });
    }

    function settle(p, to) {
      ball.style.setProperty('--x', to.x + 'px');
      ball.style.setProperty('--y', to.y + 'px');
      ball.classList.add('is-placed');
      pills.forEach(function (q) { q.classList.toggle('has-ball', q === p); });
    }

    /* mode: 'none' (just place), 'jump' (from the current spot), 'intro' (drops in from above) */
    function placeBall(p, mode) {
      if (!ball || !p || !track) return;
      var to = slotPos(p);
      var from = { x: ballX, y: ballY };
      if (ballAnim) {
        var m = new DOMMatrix(getComputedStyle(ball).transform);
        from = { x: m.e, y: m.f };
        ballAnim.cancel();
        ballAnim = null;
      }
      clearTimeout(ballTimer);
      ballX = to.x;
      ballY = to.y;
      if (mode === 'jump' && !ball.classList.contains('is-placed')) mode = 'intro';
      if (mode === 'none' || reduce || !ball.animate) { settle(p, to); return; }
      if (mode === 'jump' && Math.abs(to.x - from.x) < 2 && Math.abs(to.y - from.y) < 2) { settle(p, to); return; }

      pills.forEach(function (q) { q.classList.remove('has-ball'); });
      ball.classList.add('is-placed');
      ball.style.setProperty('--x', to.x + 'px');
      ball.style.setProperty('--y', to.y + 'px');

      /* 1. flight, sampled from real physics: steady sideways speed, gravity pulls the height into a parabola
         (y = y0 + b·t + c·t²); it ends with the ball's centre crossing the rim on the way down.
         Intro: a free fall from above (y grows with t²). */
      var rim = { x: to.x, y: to.y - RIM };
      var G = 1500; /* gravity, px/s²: the same for every jump, so time in the air depends only on height */
      /* headroom: the ball must stay 4px under the search box wherever it passes beneath it */
      var box = null;
      if (input) {
        var sr = input.getBoundingClientRect(), trr = track.getBoundingClientRect();
        box = { l: sr.left - trr.left, r: sr.right - trr.left, b: sr.bottom - trr.top + 4 };
      }
      var bw = ball.offsetWidth || 16;
      function clear(x, y) { return !box || x + bw < box.l || x > box.r || y >= box.b; }
      /* the parabola from `from` to the rim that rises H above the higher end: y = y0 + b·t + c·t² */
      function arc(H) {
        var A = from.y - (Math.min(from.y, rim.y) - H);
        var D = rim.y - from.y;
        var bq = -2 * A - 2 * Math.sqrt(A * A + A * D);
        return { b: bq, c: D - bq };
      }
      function fits(H) {
        var q = arc(H);
        for (var j = 0; j <= 40; j++) {
          var u = j / 40;
          if (!clear(from.x + (rim.x - from.x) * u, from.y + q.b * u + q.c * u * u)) return false;
        }
        return true;
      }

      var frames = [], T, N = 0.3, k, t, i, steps = 30;
      var dist = Math.hypot(to.x - from.x, to.y - from.y);
      var flight = [];
      if (mode === 'intro') {
        var drop = 70;
        while (drop > 24 && !clear(rim.x, rim.y - drop)) drop -= 2;
        var top = rim.y - drop;
        T = Math.sqrt((2 * (rim.y - top)) / G);
        for (i = 0; i <= steps; i++) {
          t = i / steps;
          flight.push({ x: rim.x, y: top + (rim.y - top) * t * t, o: Math.min(1, t * 4) });
        }
      } else {
        /* longer jumps go higher (a lob, not a line drive), as high as the search box allows */
        var H = Math.max(42, Math.min(window.innerWidth >= 990 ? 86 : 52, 42 + dist * 0.1));
        while (H > 24 && !fits(H)) H -= 2;
        var q = arc(H), bq = q.b, cq = q.c;
        T = Math.sqrt((2 * cq) / G); /* c = g·T²/2 */
        for (i = 0; i <= steps; i++) {
          t = i / steps;
          flight.push({ x: from.x + (rim.x - from.x) * t, y: from.y + bq * t + cq * t * t, o: 1 });
        }
      }
      var total = T + N;
      flight.forEach(function (f, j) {
        t = j / steps;
        /* depth cue: the ball gets a little smaller in the last stretch so it fits through the rim */
        k = t < 0.75 ? 1 : 1 - 0.22 * ((t - 0.75) / 0.25);
        frames.push({ transform: tf(f.x, f.y, +k.toFixed(3)), opacity: f.o, offset: (t * T) / total, easing: 'linear' });
      });
      /* 2. the net catches it: sinks a little, comes back up, settles */
      frames.push({ transform: tf(to.x, to.y + 4, 0.8), opacity: 1, offset: (T + 0.1) / total, easing: 'cubic-bezier(.3,0,.4,1)' });
      frames.push({ transform: tf(to.x, to.y - 1, 0.94), opacity: 1, offset: (T + 0.2) / total, easing: 'ease-in-out' });
      frames.push({ transform: tf(to.x, to.y, 1), opacity: 1, offset: 1 });

      var ms = total * 1000;
      ballAnim = ball.animate(frames, { duration: ms });
      /* backspin like a real shot: turns against the direction it travels, slows in the net */
      if (svg && mode !== 'intro') {
        var dir = to.x >= from.x ? 1 : -1;
        var turn = -dir * 360 * Math.max(0.8, Math.min(2.2, dist / 140));
        svg.animate([
          { transform: 'rotate(0deg)', easing: 'linear' },
          { transform: 'rotate(' + turn + 'deg)', offset: T / total, easing: 'ease-out' },
          { transform: 'rotate(' + (turn - dir * 25) + 'deg)' }
        ], { duration: ms });
      }
      /* squash as the net catches it */
      if (hop && hop.animate) {
        hop.animate([
          { transform: 'none', offset: 0 },
          { transform: 'none', offset: (T + 0.04) / total },
          { transform: 'scale(1.14, 0.86)', offset: (T + 0.1) / total },
          { transform: 'scale(0.96, 1.04)', offset: (T + 0.2) / total },
          { transform: 'none', offset: 1 }
        ], { duration: ms });
      }
      ballTimer = setTimeout(function () { swish(p); }, T * 1000 - 20);
      ballAnim.onfinish = function () {
        ballAnim = null;
        settle(p, to);
      };
    }

    function keepPillInView(p) {
      if (!scroller || scroller.scrollWidth <= scroller.clientWidth) return;
      var left = p.offsetLeft - 16;
      var right = p.offsetLeft + p.offsetWidth + 16 - scroller.clientWidth;
      if (scroller.scrollLeft > left) scroller.scrollTo({ left: left, behavior: reduce ? 'auto' : 'smooth' });
      else if (scroller.scrollLeft < right) scroller.scrollTo({ left: right, behavior: reduce ? 'auto' : 'smooth' });
    }

    function activePill() {
      for (var i = 0; i < pills.length; i++) if (pills[i].getAttribute('data-qb-bl-topic') === topic) return pills[i];
      return pills[0];
    }

    /* --- filter ---------------------------------------------------------------------------------------- */
    function matches(c) {
      if (topic !== 'all' && (' ' + c.getAttribute('data-topics') + ' ').indexOf(' ' + topic + ' ') < 0) return false;
      if (!query) return true;
      var text = c.getAttribute('data-text') || '';
      var words = query.split(/\s+/);
      for (var i = 0; i < words.length; i++) if (words[i] && text.indexOf(words[i]) < 0) return false;
      return true;
    }

    function deal(list) {
      if (reduce) return;
      list.slice(0, 12).forEach(function (c, i) {
        c.classList.remove('qb-bl-deal', 'qb-bl-rv', 'qb-in');
        void c.offsetWidth;
        c.style.setProperty('--d', (i * 0.05).toFixed(2) + 's');
        c.classList.add('qb-bl-deal');
      });
    }

    function apply(animate) {
      var filtering = topic !== 'all' || !!query;
      root.classList.toggle('is-filtering', filtering);
      var shown = [];
      cards.forEach(function (c) {
        var on = !filtering || matches(c);
        if (filtering) {
          c.hidden = !on;
          if (on) shown.push(c);
        } else {
          c.hidden = false;
        }
      });
      if (empty) empty.hidden = !filtering || shown.length > 0;
      if (storeSearch) {
        storeSearch.href = (storeSearch.getAttribute('href').split('?')[0]) + (query ? '?type=article&q=' + encodeURIComponent(query) : '');
      }
      if (status) {
        if (!filtering) status.textContent = '';
        else status.textContent = shown.length === 1 ? '1 article' : shown.length + ' articles';
      }
      if (animate && filtering) deal(shown);
      else if (animate && !filtering) {
        deal(cards.filter(function (c) { return c.offsetParent !== null; }).concat(grid.querySelector('[data-qb-bl-shop]') || []));
      }
    }

    function setTopic(t, animate) {
      topic = t;
      pills.forEach(function (p) {
        var on = p.getAttribute('data-qb-bl-topic') === t;
        p.classList.toggle('is-on', on);
        p.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      var p = activePill();
      keepPillInView(p);
      if (animate && scroller && scroller.scrollWidth > scroller.clientWidth && !reduce) {
        /* wait for the row to finish scrolling the pill into view, then jump */
        setTimeout(function () { placeBall(p, 'jump'); }, 280);
      } else {
        placeBall(p, animate ? 'jump' : 'none');
      }
      apply(animate);
      if (history.replaceState) {
        var url = location.pathname + location.search + (t === 'all' ? '' : '#topic-' + t);
        history.replaceState(history.state, '', url);
      }
    }

    pills.forEach(function (p) {
      p.addEventListener('click', function () {
        var t = p.getAttribute('data-qb-bl-topic');
        if (t === topic) return;
        setTopic(t, true);
      });
    });

    /* --- search ---------------------------------------------------------------------------------------- */
    var typing = 0;
    if (input) {
      input.addEventListener('input', function () {
        if (clear) clear.hidden = !input.value;
        clearTimeout(typing);
        typing = setTimeout(function () {
          var q = input.value.trim().toLowerCase();
          if (q === query) return;
          query = q;
          apply(true);
        }, 140);
      });
    }
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (input) input.blur();
      });
    }
    function resetSearch() {
      if (!input) return;
      input.value = '';
      if (clear) clear.hidden = true;
      query = '';
    }
    if (clear) {
      clear.addEventListener('click', function () {
        resetSearch();
        apply(true);
        input.focus();
      });
    }
    var reset = root.querySelector('[data-qb-bl-reset]');
    if (reset) {
      reset.addEventListener('click', function () {
        resetSearch();
        setTopic('all', true);
      });
    }

    /* --- Show more ------------------------------------------------------------------------------------- */
    function updateMore() {
      var closed = later.filter(function (c) { return !c.classList.contains('is-shown'); }).length;
      var open = total - closed;
      if (count) count.textContent = 'Showing ' + open + ' of ' + total + ' articles';
      if (bar) bar.style.transform = 'scaleX(' + (open / total).toFixed(3) + ')';
      if (moreWrap) moreWrap.classList.toggle('is-done', closed === 0);
    }
    if (more) {
      more.addEventListener('click', function () {
        var next = later.filter(function (c) { return !c.classList.contains('is-shown'); }).slice(0, STEP);
        next.forEach(function (c) { c.classList.add('is-shown'); });
        deal(next);
        updateMore();
        var link = next[0] && next[0].querySelector('.qb-bl-card__title a');
        if (link) link.focus({ preventScroll: true });
      });
    }

    /* --- scroll reveal (only what starts below the first screen) ---------------------------------------- */
    if (hasIO && !reduce) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          e.target.classList.add('qb-in');
          io.unobserve(e.target);
        });
      }, { rootMargin: '0px 0px -40px 0px', threshold: 0.05 });
      var cols = 0;
      var items = Array.prototype.slice.call(root.querySelectorAll('.qb-bl-side .qb-bl-card, [data-qb-bl-grid] > *'));
      items.forEach(function (el) {
        if (el.offsetParent === null) return;
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight * 0.92) return;
        cols = getComputedStyle(grid).gridTemplateColumns.split(' ').length || 1;
        var i = Array.prototype.indexOf.call(el.parentNode.children, el);
        el.style.setProperty('--d', ((i % cols) * 0.08).toFixed(2) + 's');
        el.classList.add('qb-bl-rv');
        io.observe(el);
      });
    }

    /* --- start ----------------------------------------------------------------------------------------- */
    var m = /^#topic-([\w-]+)$/.exec(location.hash);
    var fromHash = m && pills.some(function (p) { return p.getAttribute('data-qb-bl-topic') === m[1]; });
    if (fromHash) setTopic(m[1], false);
    /* the ball drops through the picked pill's hoop once the header has dropped in */
    var introDone = false;
    function intro() {
      if (introDone) return;
      introDone = true;
      if (ball && ball.classList.contains('is-placed')) return;
      placeBall(activePill(), 'intro');
    }
    if (reduce) { introDone = true; placeBall(activePill(), 'none'); }
    else setTimeout(intro, 650);

    function replace() { if (introDone && !ballAnim) placeBall(activePill(), 'none'); }
    if ('ResizeObserver' in window && track) new ResizeObserver(replace).observe(track);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(replace);
  }

  function start() {
    document.querySelectorAll('[data-qb-bl]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
